import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { money } from "@/lib/api";

export function RewardsBox() {
  const { quote, setRewards } = useCart();
  const { user } = useAuth();
  const [amt, setAmt] = useState("");
  if (!quote) return null;
  if (!user) return <p className="text-xs bg-[var(--c-muted)] p-3" data-testid="rewards-signin-note"><Link to="/login?next=/checkout" className="underline">Sign in</Link> to earn and spend your <Link to="/pages/rewards" className="underline">Somnio VIP</Link> rewards.</p>;
  const avail = quote.rewards_available || 0;
  if (avail <= 0 && !quote.rewards_applied) return null;
  const max = Math.round(Math.min(avail, quote.subtotal - quote.discount) * 100) / 100;
  const apply = () => { const n = Number(amt); setRewards(n > 0 ? Math.min(n, max) : max); setAmt(""); };
  return (
    <div className="border border-neutral-200 bg-[var(--c-bg)] p-4 space-y-3" data-testid="rewards-box">
      <div className="flex justify-between items-baseline gap-3">
        <p className="eyebrow">Somnio VIP rewards</p>
        <p className="text-xs text-neutral-600" data-testid="rewards-available">{money(avail)} available</p>
      </div>
      {quote.rewards_applied > 0 ? (
        <div className="flex items-center justify-between text-sm">
          <span className="text-emerald-700" data-testid="rewards-applied">{money(quote.rewards_applied)} applied to this order</span>
          <button onClick={() => setRewards(null)} className="text-xs underline" data-testid="rewards-remove-button">Remove</button>
        </div>
      ) : (
        <div className="flex">
          <input type="number" min="0" step="0.01" max={max} value={amt} onChange={(e) => setAmt(e.target.value)} placeholder={`Amount (up to ${money(max)})`}
            className="flex-1 min-w-0 border border-neutral-300 bg-white px-3 py-2.5 text-sm outline-none focus:border-neutral-900" data-testid="rewards-amount-input" />
          <button onClick={apply} className="btn-ink px-5 text-xs tracking-widest uppercase" data-testid="rewards-apply-button">{amt ? "Apply" : "Use all"}</button>
        </div>
      )}
    </div>
  );
}
